module.exports = __webpack_public_path__ + "img/Truck5.026c6a62.jpg";